import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import TimedMessage from '../TimedMessage'
import { MessageOptions, Option } from '../MessageOptions'

export const Astro = (props) => {
  const ts = props.message.timestamp
  return (
    <div className="message message-astro">
      <div className="body">
        <TimedMessage startAt={ts} idx={0}>
          <FormattedMessage id="chat.astro.intro-1" />
        </TimedMessage>
        <TimedMessage startAt={ts} idx={1}>
          <FormattedMessage id="chat.astro.intro-2" />
        </TimedMessage>
        <TimedMessage startAt={ts} idx={2}>
          <FormattedMessage id="chat.astro.intro-3" />
        </TimedMessage>
      </div>

      <MessageOptions prompt="chat.options.something-else" startAt={ts} idx={3}
        next={props.next} sendMessage={props.sendMessage}>
        <Option to="works" text="chat.options.show-work" />
        <Option to="glue" text="chat.options.about-glue" />
        <Option to="contact" text="chat.options.contact" />
      </MessageOptions>
    </div>
  )
}

Astro.propTypes = {
  next: PropTypes.string,
  message: PropTypes.object,
  sendMessage: PropTypes.func.isRequired
}

export default Astro
